/* jshint esversion: 6, unused: true */

import "isomorphic-fetch"
require('es6-promise').polyfill();


function classList(elt) {
  var list = elt.classList;
  return {
    toggle: function(c) {
      list.toggle(c);
      return this;
    },
    add: function(c) {
      list.add(c);
      return this;
    },
    remove: function(c) {
      list.remove(c);
      return this;
    }
  };
}

function show_applied_descriptor(products) {

  let sentence = ''
  let number = products.length;
  if (number === 3) {
    sentence = 'Your promotion code has been applied to all packages'
  } else {
    const sentence_arr = []

    if (products.indexOf('bundle') != -1) {
      sentence_arr.push ('BUNDLE package')
    }
    if (products.indexOf('print') != -1) {
      sentence_arr.push('NEWSPAPER package')
    }
    if (products.indexOf('digital') != -1) {
      sentence_arr.push('DIGITAL package')
    }

    if (number == 2) {
      sentence = `Your promotion code has been applied to the ${sentence_arr[0]} and ${sentence_arr[1]}`
    } else {
      sentence = `Your promotion code has been applied to the ${sentence_arr[0]}`
    }
  }
  document.getElementById('applied-product').textContent = sentence
  document.getElementById('applied-product').classList.remove('hidden')
}

function change_element_visibility(type, visibility) {
  [].concat( document.getElementsByClassName(type) ).forEach(function(v) {
    [].slice.call(v).forEach(function (e) {
      if ( visibility === 'hide' ) {
        e.classList.add( 'hide' );
      } else {
        e.classList.remove( 'hide' );
      }
    });
  });
}

function update_td(type, data, mediacode) {

  /*if (type !== 'print') {
    let typeChar = mediacode.slice(-1);
    if (typeChar !== 'B' && typeChar !== 'D') {
      if (type === 'digital') {
        mediacode = mediacode + 'D';
      } else if (type === 'bundle') {
        mediacode = mediacode + 'B';
      }
    }
  }
  else {
    mediacode = mediacode + 'P';
  }*/

  // trial, debit, 15 weeks, 26 weeks, 52 weeks
  let trial = document.getElementsByClassName(`js-${type}_price_trial`);
  let trialrrp = document.getElementsByClassName(`js-${type}_trial_rrp`);
  let trialsaving = document.getElementsByClassName(`js-${type}_trial_saving`);
  let triallength = document.getElementsByClassName(`js-${type}-link`);
  let trialfoot = document.getElementsByClassName(`js-foot-${type}`);
  //if(data['trial_price']!=='0.00') {
    if(data['trial_price'] == '0.00') {
      data['trial_price_nice'] = 'free';
    }
    else {
      data['trial_price_nice'] = data['trial_price'];
    }
    trial[0].textContent = `£` + data[`trial_price`] + `*`;
    trialrrp[0].textContent = `£` + data[`trial_rrp`] + `*`;
    trialsaving[0].textContent = `Save ` + data[`trial_saving`] + `%`;
    triallength[0].innerHTML = `Try ` + data[`trial_length`] + ` issues for £`+data['trial_price'];
    trialfoot[0].innerHTML = 'The first ' + data['trial_length'] + ' issues are £' + data['trial_price_nice'] + '. After the ' + data['trial_length'] + ' issues trial the subscription will step up to \xA3' + data['dd_price'] + ' every '+data['dd_period']+' weeks. You can cancel at any time.';
    trial[1].textContent = `£` + data[`trial_price`] + `*`;
    triallength[3].innerHTML = `Try ` + data[`trial_length`] + ` issues for £`+data['trial_price'];
  //}
  //let week15 = document.getElementsByClassName(`js-${type}_price_15_weeks`);
  //week15[0].textContent = `£` + data[`${type}_price_15_weeks`];
  let weeks26 = document.getElementsByClassName(`js-${type}_price_26_weeks`);
  let weeks26rrp = document.getElementsByClassName(`js-${type}_26_weeks_rrp`);
  let weeks26saving = document.getElementsByClassName(`js-${type}_26_weeks_saving`);
  if(data['sub26_price']!=='0.00') {
    weeks26[0].textContent = `£` + data[`sub26_price`];
    weeks26rrp[0].textContent = `£` + data[`sub26_rrp`];
    weeks26saving[0].textContent = `Save ` + data[`sub26_saving`] + `%`;
    weeks26[1].textContent = `£` + data[`sub26_price`];
  }
  let weeks52 = document.getElementsByClassName(`js-${type}_price_52_weeks`);
  let weeks52rrp = document.getElementsByClassName(`js-${type}_52_weeks_rrp`);
  let weeks52saving = document.getElementsByClassName(`js-${type}_52_weeks_saving`);
  if(data['sub52_price']!=='0.00') {
    weeks52[0].textContent = `£` + data[`sub52_price`];
    weeks52rrp[0].textContent = `£` + data[`sub52_rrp`];
    weeks52saving[0].textContent = `Save ` + data[`sub52_saving`] + `%`;
    weeks52[1].textContent = `£` + data[`sub52_price`];
  }
  if ( type === 'print' ) {
    if ( data['trial_length'] === '26' ) {
      triallength[0].innerHTML = 'Half price for 6 months';
      triallength[3].innerHTML = 'Half price for 6 months';
      change_element_visibility( 'print_2020', 'hide');
      change_element_visibility( 'print_26_weeks', 'hide');
      change_element_visibility( 'footnote2020', 'hide');
    } else {
      if ( ! document.getElementsByClassName('print_trial')[0].classList.contains( 'hide' ) ) {
        change_element_visibility( 'print_2020', 'show');
        change_element_visibility( 'print_26_weeks', 'show');
        change_element_visibility( 'footnote2020', 'show');
      }
    }
  }

  [].concat(document.getElementsByClassName('js-' + type + '-link')).forEach(function(v) {
    [].slice.call(v).forEach(function(e) {
      e.href = e.href + '&offer=' + mediacode
    })
  });

  return true;
}

const codecheck = document.getElementById('js-checkcode');

codecheck.addEventListener('click', function() {

  this.textContent = "Checking";

  let mediacode = document.getElementById('js-mediacode').value;
  let mediacodeUC = mediacode.toUpperCase();

  classList(this).remove("fn-btn-green").remove("fn-btn-red").add("fn-btn-orange");

  fetch(`/ajax/mediacode-lookup.php?code=${mediacodeUC}`, {
      headers: {
        'Authorization': 'Basic Zmlyc3RuZXdzOmZpcnN0bmV3cw=='
      }
    })
    //fetch('https://api.myjson.com/bins/17wyah')
    .then(function(response) {
      return response.json()
    })
    .then(function(j) {
      
      if(j.redirect == 'TRUE') {
        window.location.replace('https://subscribe.firstnews.co.uk/christmas/?offer='+mediacode+'#js-promotion');
      }

      if (Object.keys(j).length === 0) {
        throw new Error('error')
      }
      const updated_products = []
      
      if (j.print) {
        update_td('print', j.print, mediacodeUC)
        updated_products.push('print');
        console.log('Updating print pricing');
        console.table(updated_products);
      }
      if (j.digital) {
        update_td('digital', j.digital, mediacodeUC)
        updated_products.push('digital');
        console.log('Updating digital pricing');
        console.table(updated_products);
      }
      if (j.bundle) {
        update_td('bundle', j.bundle, mediacodeUC)
        updated_products.push('bundle');
        console.log('Updating bundle pricing');
        console.table(updated_products);
      }

      if (Object.keys(j).length === 1) {
        if (j.print) {
          document.getElementById('js-package-print').click()
        } else if (j.bundle) {
          document.getElementById('js-package-bundle').click()
        } else if (j.digital) {
          document.getElementById('js-package-digital').click()
        }
      }

      show_applied_descriptor(updated_products)

      classList(codecheck).remove("fn-btn-orange").add("fn-btn-green");

      codecheck.textContent = "Applied ✔";
      document.getElementById('js-promotion').textContent = 'Your code has been applied'

    }).catch(function() {
      classList(codecheck).remove("fn-btn-orange").add("fn-btn-red");
      codecheck.textContent = "Invalid!";
      document.getElementById('js-promotion').textContent = 'Invalid promotion code'
      setTimeout(function() {
        classList(codecheck).remove("fn-btn-red").add("fn-btn-green");
        codecheck.textContent = "Try again?"
      }, 2000)
    });
});